import React from "react";
import "./VideoCustomModal.css"; 

const VideoModal = ({ open, onClose, videoUrl }) => {
    if (!open) return null;

    return (
        <div className="video-modal-overlay" onClick={onClose}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="video-modal-close" onClick={onClose}>
                    ✕
                </button>

                <video controls className="video-player">
                    <source src={videoUrl} type="video/mp4" />
                </video>
            </div>
        </div>
    );
};

export default VideoModal;